module.exports = __webpack_public_path__ + "static/media/clearIcon.3893b639.svg";